import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
    RewardPropTypes,
    RewardsMetaPropTypes,
    BalancePropTypes,
} from 'containers/WGCWXShop/propTypes'

import WGCWXRewardsTankCard from '../WGCWXRewardsTankCard/WGCWXRewardsTankCard'
import { Tooltip, ScrollArea } from 'react-wot-bootstrap'

import { REWARDS_TYPES } from 'containers/WGCWXShop/constants'
import { VEHICLE_TO_COMPARE_TOOLTIP } from 'components/VehicleAddToComparison/constants'
import {
    REWARDS_TANKS_SECTION,
    REWARDS_TANK_HAS_AUCTION_TICKET,
    REWARDS_TANK_HAS_NO_AUCTION_TICKET,
    ENOUGH_PFP_FOR_TANK_RECEIVING,
    NOT_ENOUGH_PFP_FOR_TANK_RECEIVING,
    EVENT_FINISHED_HAS_NO_AUCTION_TICKET,
} from '../../translations'

import styles from '../../WGCWXRewards.scss'

class WGCWXRewardsGrid extends React.Component {
    static propTypes = {
        rewards: PropTypes.arrayOf(RewardPropTypes),
        rewardsMeta: RewardsMetaPropTypes,
        accountBalance: BalancePropTypes,
        selectReward: PropTypes.func.isRequired,
        isAddToComparisonAvailable: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            scrollableAreaHeight: 0,
        }

        this.BOTTOM_SCROLL_OFFSET = 10
        this.SCROLL_STEP = 50
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)

        this.setScrollAreaHeight()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setScrollAreaHeight()
    }

    setScrollAreaHeight() {
        if (!this._body) return
        const coords = this._body.getBoundingClientRect()
        const height = window.innerHeight - coords.top - this.BOTTOM_SCROLL_OFFSET
        this.setState({ scrollableAreaHeight: height })
    }

    renderRewardsConditions() {
        const {
            places,
            purchaseDatetimeEnd,
            famePoints,
            hasAuctionTicket,
            currentBet,
        } = this.props.rewardsMeta

        const rewardsPrices = this.props.rewards.map(reward => reward.price)
        const minRewardPrice = Math.min(...rewardsPrices)

        const isEnoughPfp = (famePoints >= minRewardPrice)
        const datetimeEnd = moment.utc(purchaseDatetimeEnd).local()

        switch (true) {
        case !minRewardPrice && !hasAuctionTicket:
            return (
                <p className={styles.requirements}>
                    {REWARDS_TANK_HAS_NO_AUCTION_TICKET(places)}
                </p>
            )
        case !minRewardPrice && hasAuctionTicket:
            return (
                <p className={styles.requirements}>
                    {REWARDS_TANK_HAS_AUCTION_TICKET(places)}
                </p>
            )
        case minRewardPrice && isEnoughPfp:
            return (
                <p className={styles.requirements}>
                    {ENOUGH_PFP_FOR_TANK_RECEIVING(datetimeEnd, places)}
                </p>
            )
        case minRewardPrice && !hasAuctionTicket && !currentBet:
            return (
                <p className={styles.requirements}>
                    {EVENT_FINISHED_HAS_NO_AUCTION_TICKET}
                </p>
            )
        default:
            return (
                <p className={styles.requirements}>
                    {NOT_ENOUGH_PFP_FOR_TANK_RECEIVING(datetimeEnd)}
                </p>
            )
        }
    }

    render() {
        const tanksRewards = this.props.rewards.filter(reward =>
            (reward.type === REWARDS_TYPES.TANK && reward.vehicleParams)
        )

        return (
            <div className={styles.content}>
                <h2 className={styles.category}>
                    {REWARDS_TANKS_SECTION}
                </h2>
                {this.renderRewardsConditions()}
                <div ref={c => this._body = c} className={styles.body}>
                    <ScrollArea
                        stepHeight={this.SCROLL_STEP}
                        scrollableAreaHeight={this.state.scrollableAreaHeight}
                    >
                        <div className={styles.grid}>
                             {tanksRewards.map(tank => (
                                <WGCWXRewardsTankCard
                                    key={tank.id}
                                    tank={tank}
                                    tanks={tanksRewards}
                                    rewardsMeta={this.props.rewardsMeta}
                                    accountBalance={this.props.accountBalance}
                                    selectReward={this.props.selectReward}
                                    isAddToComparisonAvailable={this.props.isAddToComparisonAvailable}
                                />)
                             ) }
                        </div>
                </ScrollArea>
                </div>
                {
                    this.props.isAddToComparisonAvailable &&
                    <Tooltip id={VEHICLE_TO_COMPARE_TOOLTIP.id}>
                        {VEHICLE_TO_COMPARE_TOOLTIP.message}
                    </Tooltip>
                }
            </div>
        )
    }
}

export default WGCWXRewardsGrid



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsGrid/WGCWXRewardsGrid.jsx